import {Component, OnInit} from '@angular/core';
import {StoreService} from '../../shared';
import {ThreatService} from '../../shared/threat/threat.service';
import {MockApiService} from '../../shared';

@Component({
    selector: 'customer-report',
    templateUrl: './customer-report.component.html',
    styleUrls: ['./customer-report.component.css']
})
export class CustomerReportComponent implements OnInit {

    subscriptions: any = {
        autoRefresh: null,
        threats: null
    };

    timePeriods = ['a', 'h', 'd', 'w', 'm', 'q', 'y'];
    timePeriodIndex = 3;

    isThreatsDataLoading: boolean;
    threatsParams: any[ ] = [
        {
            timePeriod: 'a',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'h',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'd',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'w',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'm',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'q',
            param2: null,
            param3: null,
        },
        {
            timePeriod: 'y',
            param2: null,
            param3: null,
        }
    ];
    threatsFromAPI = [];

    // Default Alert Time alertTimePeriod
    alertTimePeriod = 'w';
    showRanges = false;
    data: any;

    constructor(private store: StoreService, private mockApi: MockApiService, private threatService: ThreatService) {
        this.data = {
            summary: [],
            highRiskDevices: []
        };
    }

    ngOnInit() {

        const self = this;

        self.subscriptions.customerReportData = self.mockApi.getMockData('customer-report.json').subscribe((data) => {
            // console.log('customer report data =', data);
            self.data = data;
        });

        self.subscriptions.threats = self.store.onChange('threats', function (threats) {
            self.threatsFromAPI = threats;
        });

        self.getThreats(this.timePeriodIndex, true);
    }

    sum(arr) {
        return arr.reduce((a, i) => {
            return a + i;
        }, 0);
    }

    range(n) {
        return new Array(n).fill(1);
    }

    getThreats(threatsParamsIndex, forceFetchThreatsFromAPI = false, silent = false) {

        const self = this;

        if (!silent) {
            self.isThreatsDataLoading = true;
        }

        const params = self.threatsParams[threatsParamsIndex];

        self.threatService.getThreats(params, forceFetchThreatsFromAPI).subscribe(function (threats) {

            // self.threats = threats;
            self.store.update('threats', threats);
            // self.isThreatsDataLoading = false;
            // self.isThreatsDataError = false;
            // self.prepareThreatBubbleChartData();

            // console.log('threats = ', threats);

        }, function (err) {

            // console.log('Error in getting threats. Called from dashboard.component.ts');
            // console.log(err);

        });
    }

}



// WEBPACK FOOTER //
// /app/src/app/containers/customer-report/customer-report.component.ts